import React, { useState, useEffect } from 'react'
import './technologies.css'
import { motion } from 'framer-motion';
import C2wTechnolgyCard from '../../../common/C2wHome/technology/technolgyCard';
import C2wSuperxVideoSrc from '../../../common/C2wSuperxHome/videoSrc/videoSrc';


function C2wTechnologies( { isVisible } ) {

  const [videoSource, setVideoSource] = useState('/assets/superx/videos/classvideo.mp4');
  const arr1 = [{ imageName: 'javaLogoSvg', title: 'Java' }, { imageName: 'pythonLogoSvg', title: 'Python' }, { imageName: 'cLogoSvg', title: 'C' }, { imageName: 'cppLogoSvg', title: 'CPP' }, { imageName: 'dsaLogoSvg', title: 'DSA' }]
  const arr2 = [{ imageName: 'osLogoSvg', title: 'OS' }, { imageName: 'dbmsLogoSvg', title: 'DBMS' }, { imageName: 'mlLogoSvg', title: 'ML' }, { imageName: 'iotLogoSvg', title: 'IOT' }]
  const arr3 = [{ imageName: 'flutterSvg', title: 'Mobile' }, { imageName: 'reactLogoSvg', title: 'Web' }, { imageName: 'springLogoSvg', title: 'Backend' }]
  const mobileArr = [
    { imageName: 'javaLogoSvg', title: 'Java' },
    { imageName: 'pythonLogoSvg', title: 'Python' },
    { imageName: 'cLogoSvg', title: 'C' },
    { imageName: 'cppLogoSvg', title: 'CPP' },
    { imageName: 'dsaLogoSvg', title: 'DSA' },
    { imageName: 'osLogoSvg', title: 'OS' },
    { imageName: 'dbmsLogoSvg', title: 'DBMS' },
    { imageName: 'mlLogoSvg', title: 'ML' },
    { imageName: 'iotLogoSvg', title: 'IOT' },
    { imageName: 'flutterSvg', title: 'Mobile' },
    { imageName: 'reactLogoSvg', title: 'Web' },
    { imageName: 'springLogoSvg', title: 'Backend' }
  ]


/**
 * @state windowWidth
 * @hook useEffect - Window Resize Listener
 * @author Vishal Lohbande
 *
 * Description:
 * - Initializes `windowWidth` state with the current window width.
 * - Adds a resize event listener on the window to update `windowWidth` whenever the window size changes.
 *
 * Behavior:
 * - The `handleResize` function updates the `windowWidth` state with the new window width.
 * - Cleanup function removes the event listener on component unmount to prevent memory leaks.
 *
 * Usage:
 * - Useful for responsive design decisions based on the current viewport width.
 */
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  return (
    windowWidth > 620 ? (
      <div className='C2wTechnologies_ctn'>
        <C2wSuperxVideoSrc videoSource={videoSource} />
        <div className='C2wTechnologies_ctn_heading'>
          <motion.div className='C2WTechnologies_heading_motion' 
            initial={{ y: -70, opacity: 0 }} 
            layout
            animate={ isVisible ? { y: 20, opacity: 1 } : {}} 
            transition={{ duration: 1.5, ease: "easeInOut" }}>
            <div className='C2WTechnologies_heading'>
              <div className='C2WTechnologies_heading_main'>Know the <span className='C2wSpanCode'>code</span> till the <span className='C2wSpanCore'>core.</span></div>
              <div className='C2WTechnologies_heading_Submain'>{'Build rock solid foundation of programming'}</div>
            </div>
          </motion.div>
        </div>
        <div className='C2wTechnologies_ctn_holder'>
          <div className='C2wTechnologies_cards_holder'>
            {arr1 &&
              arr1.map((obj, Innerindex) => (
                <motion.div
                  key={Innerindex}
                  layout
                  className="C2wTeachnologyCard_div_motion"
                  initial={{ opacity: 0, y: 70 }}
                  animate={ isVisible ? { opacity: 1, y: 0, ease: [0.25, 0.8, 0.25, 1],
                   } : {}}       
                   transition={ isVisible ? {
                    type: 'spring',
                    duration: 0.4,
                    delay: 0.5 + Innerindex * 0.1,
                    ease: 'easeInOut',
                  } : {}}
                >
                  <C2wTechnolgyCard obj={obj} />
                </motion.div>
              ))}
          </div>

          <div className='C2wTechnologies_cards_holder'>
            {arr2 &&
              arr2.map((obj, Innerindex) => (
                <motion.div
                  key={Innerindex}
                  layout
                  className="C2wTeachnologyCard_div_motion"
                  initial={{ opacity: 0, y: 70 }}
                  animate={ isVisible ? { opacity: 1, y: 0 } : {}}
                  transition={ isVisible ? {
                    type: 'spring',
                    duration: 0.4,
                    delay: 1 + Innerindex * 0.1,
                    ease: 'easeInOut',
                  } : {}}
                >
                  <C2wTechnolgyCard obj={obj} />
                </motion.div>
              ))}
          </div>

          <div className='C2wTechnologies_cards_holder'>
            {arr3 &&
              arr3.map((obj, Innerindex) => (
                <motion.div
                  key={Innerindex}
                  layout
                  className="C2wTeachnologyCard_div_motion"
                  initial={{ opacity: 0, y: 70 }}
                  animate={ isVisible ? { opacity: 1, y: 0 } : {}}
                  transition={ isVisible ? {
                    type: 'spring',
                    duration: 0.4,
                    delay: 1.5 + Innerindex * 0.1,
                    ease: 'easeInOut',
                  } : {}}
                >
                  <C2wTechnolgyCard obj={obj} />
                </motion.div>
              ))}
          </div>

        </div>
      </div>
    ) : (
      <div className='C2wTechnologies_ctn'>
        <div className='C2wTechnologies_ctn_heading'>
          <motion.div className='C2WTechnologies_heading_motion' initial={{ y: 0, opacity: 0 }} animate={ isVisible ? { y: 70, opacity: 1 } : {}} transition={{ duration: 2, ease: "easeOut" }}>
            <div className='C2WTechnologies_heading'>
              <div className='C2WTechnologies_heading_main'>Know the <span className='C2wSpanCode'>code</span> till the <span className='C2wSpanCore'>core.</span></div>
              <div className='C2WTechnologies_heading_Submain'>{'Build rock solid foundation of Programming'}</div>
            </div>
          </motion.div>
        </div>
        <div className='C2wTechnologies_ctn_holder'>
          <div className='C2wTechnologies_cards_holder'>
            {mobileArr &&
              mobileArr.map((obj, Innerindex) => (
                <motion.div
                  key={Innerindex}
                  className="C2wTeachnologyCard_div_motion"
                  initial={{ opacity: 0, y: 70 }}
                  animate={ isVisible ? { opacity: 1, y: 0 } : {}}
                  transition={{
                    duration: 0.4,
                    ease: 'easeInOut',
                  }}
                >
                  <C2wTechnolgyCard obj={obj} />
                </motion.div>
              ))}
          </div>
        </div>
      </div>
    )
  )
}

export default C2wTechnologies
